/**
 * palette-scopes.ts — umowne „slugi" zakresu palety klocków kreatora formatek.
 *
 * Paleta (`LayoutElementsPalette`) filtruje klocki z `allowedModules` po propie
 * `moduleSlug`: builder kartoteki systemowej podaje slug kartoteki (np. `contractors`,
 * `sale_invoices`), a builder bez znajomości modułu nie podaje nic (klocki z
 * `allowedModules` są wtedy ukryte).
 */

/**
 * Zakres palety kreatora MODUŁÓW WŁASNYCH tenanta. Adapter modułu własnego
 * (`useTenantModuleBuilderAdapter`) przekazuje go jako `moduleSlug` do palety, więc klocek
 * może jawnie dopuścić moduły własne, wpisując tę stałą do swojego `allowedModules`
 * (np. `process_view` — historia procesu akceptacji rekordu modułu własnego).
 *
 * Wartość celowo nie wygląda jak slug (podwójne podkreślniki na brzegach) — żaden slug
 * kartoteki systemowej się z nią nie zderzy, więc klocki scope'owane pod kartoteki
 * systemowe nie „przeciekają" do kreatora modułów własnych. Szablony modułów
 * (hub Kreatora) NIE dostają tego zakresu — klocek dopuszczony tutaj nie pojawia się
 * w ich palecie.
 */
export const CUSTOM_MODULE_PALETTE_SCOPE = '__custom_module__';
